import Criteria from './Criteria';

export default Criteria;
